import { useMutation } from '@apollo/client';
import { Mutation, MutationVerifyAccountArgs } from 'graphql/generated/graphqlTypes';
import { VERIFY_ACCOUNT } from 'graphql/mutations';
import { setCurrentTenantAction } from 'state/actions/currentTenant';
import { BaseHookProps } from '../shared/types';

const useVerifyCode = ({ handleFetchError }: BaseHookProps) => {
  const [verifyCognitoUserMutation, { loading, error }] = useMutation<
    Pick<Mutation, 'verifyAccount'>,
    MutationVerifyAccountArgs
  >(VERIFY_ACCOUNT, {
    onCompleted: (data) => {
      setCurrentTenantAction(data.verifyAccount);
    },
    onError: () => {
      handleFetchError('Error while verifying user');
    }
  });

  const verifyCognitoUser = async (email: string, code: string) => {
    const result = await verifyCognitoUserMutation({
      variables: {
        email,
        code
      }
    });
    return result;
  };

  return {
    loading,
    verifyCognitoUser,
    error
  };
};

export default useVerifyCode;
